import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { openSalesIQChat } from '../utils/chat';

const NAV_DEFAULT = [
  { href: '/#home', label: 'Home' },
  { href: '/#services', label: 'Services' },
  { href: '/#guides', label: 'Transfer' },
  { href: '/#issues', label: 'Help' },
  { href: '/#blog', label: 'Blog' },
  { href: '/#contact', label: 'Contact' },
];

const NAV_GREEN = [
  { href: '/#home', label: 'Home' },
  { href: '/#about', label: 'About Us' },
  { href: '/#services', label: 'Services' },
  { href: '/#contact', label: 'Contact Us' },
];

function Header({ variant = 'default' }) {
  const isGreen = variant === 'green';
  const navItems = isGreen ? NAV_GREEN : NAV_DEFAULT;
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 960) setMenuOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <header className={`s4h-header${isGreen ? ' s4h-header--green' : ''}`}>
      <div className="s4h-header__bar">
        <Link className="s4h-header__brand" to="/" onClick={() => setMenuOpen(false)}>
          <span className="s4h-header__logo-box">
            <img src={`${process.env.PUBLIC_URL || ''}/logo.avif`} alt="" width={40} height={40} />
          </span>
          {!isGreen && (
            <span className="s4h-header__name">
              Support <em>4</em> Help
            </span>
          )}
        </Link>

        <nav id="s4h-nav" className={`s4h-header__nav ${menuOpen ? 's4h-header__nav--open' : ''}`}>
          {navItems.map(({ href, label }) => (
            <a key={href} href={href} onClick={() => setMenuOpen(false)}>
              {label}
            </a>
          ))}
          <button type="button" className="s4h-header__chat s4h-header__chat--mobile" onClick={openSalesIQChat}>
            <MessageCircle size={18} aria-hidden />
            Live chat
          </button>
        </nav>

        <div className="s4h-header__actions">
          {isGreen ? (
            <a href="/#requirements" className="s4h-header__req" onClick={() => setMenuOpen(false)}>
              System Requirements
            </a>
          ) : (
            <button type="button" className="s4h-header__chat" onClick={openSalesIQChat}>
              <MessageCircle size={18} aria-hidden />
              Live chat
            </button>
          )}
          <button
            type="button"
            className="s4h-header__menu"
            aria-expanded={menuOpen}
            aria-controls="s4h-nav"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            onClick={() => setMenuOpen((v) => !v)}
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
